<template>
  <q-dialog v-model="dialogApproveChannelsInCampaign" persistent>
    <q-card style="min-width: 600px">
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title> {{ $t('select_channel_for_request') }} </q-toolbar-title>

        <q-btn flat round dense icon="mdi-close" />
      </q-toolbar>

      <q-form @submit.prevent="onSave">
        <q-card-section class="scroll q-col-gutter-md" style="max-height: 70vh">
          <select-request
            :label="$t('select_channel')"
            v-model="selectedChannel"
            outlined
            clearable
            option-label="name"
            option-value="id"
            map-options
            @update="(value) => (selectedChannel = value === null ? null : value)"
            :rules="[isRequired]"
            lazy-rules="ondemand"
            endpoint="/redirect?app=AFFILIATE&path=/api/v2/get/affiliate/site"
          ></select-request>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right" class="q-pa-md">
          <q-btn outline :label="$t('cancel')" no-caps padding="sm lg" color="primary" @click="onClose" />
          <q-btn unelevated :label="$t('save')" no-caps padding="sm lg" color="primary" type="submit" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import CampaignMixin from '@/mixins/CampaignMixin.js';
import AdvertiserService from '@/services/AdvertiserService.js';
import SelectRequest from '@/widgets/inputsGlobal/SelectRequest.vue';
export default {
  name: 'FormRequestChannelApprovalInCampaigns',
  mixins: [CampaignMixin, AdvertiserService],
  components: { SelectRequest },
  data() {
    return {
      dumb: true,
      selectedChannel: null
    };
  },

  methods: {
    onClose() {
      this.ActionSetDialogApproveChannelsInCampaign({ value: false });
    },

    async onSave() {
      try {
        this.onLoading(true);

        const { status } = await this.requestSiteParticipationInCampaignsLot(
          this.selectedChannel.id,
          this.selectedCampaigns.map((c) => c.campaign_id)
        );

        if (status == 201) {
          this.successNotify(this.$t('site_request_for_campaigns_success'));
          this.onClose();
        }
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>

<style></style>
